<template>
	<div style="text-align: left; padding: 0px 30px">
		<el-form ref="form" :model="form" :rules="rules" label-width="130px">
			<el-form-item label="样品编号" prop="orderNo">
				<el-input v-model="form.orderNo" :disabled="true" placeholder="请输入订单编号" />
			</el-form-item>

			<el-form-item label="预期消耗量" prop="expectedConsumption">
				<el-input v-model="form.expectedConsumption" required placeholder="请输入预期消耗量，不能大于当前质量！" />
			</el-form-item>
			<el-form-item label="使用目的" prop="useTarget">
				<el-input v-model="form.useTarget" disabled required placeholder="请输入使用目的" />
			</el-form-item>
			<el-form-item label="样品借用质量" prop="borrowWeight">
				<el-input v-model="form.borrowWeight" required :disabled="typeData == '岩屑样' ? true : false" placeholder="请输入样品借用质量" />
			</el-form-item>
			<!-- <el-form-item label="使用单位法人" prop="legalPerson">
				<el-input v-model="form.legalPerson" :disabled="true" placeholder="请输入使用单位法人" />
			</el-form-item> -->
			<!--1:原样使用,2:消耗使用,3:破坏性使用,4:展览,5:教育,6:科普,7:其他 -->
			<el-form-item label="使用方式" prop="useType">
				<el-select v-model="form.useType" placeholder="请选择类型">
					<el-option v-for="dict in useTypeOption" :key="dict.value" :label="dict.label" :value="parseInt(dict.value)"></el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="开始使用时间" prop="useStartTime">
				<el-date-picker clearable v-model="form.useStartTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择开始使用时间"> </el-date-picker>
			</el-form-item>

			<el-form-item label="结束使用时间" prop="useEndTime">
				<el-date-picker clearable v-model="form.useEndTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择结束使用时间"> </el-date-picker>
			</el-form-item>

			<el-form-item label="样品使用单位/场所" required prop="companyName">
				<!-- <el-select v-model="form.companyName" @change="chageDep" placeholder="请选择使用单位名称">
					<el-option v-for="(item, index) in deptData" :key="index" :label="item.deptName" :value="item.deptName"></el-option>
				</el-select> -->
				<el-input v-model="form.companyName" placeholder="请选择样品使用单位/场所" />
			</el-form-item>

			<el-form-item label="借用责任人" required prop="usePerson">
				<el-input v-model="form.usePerson" placeholder="请输入借用责任人" />
			</el-form-item>

			<!-- <el-form-item label="测试责任人" prop="testPerson">
				<el-input v-model="form.testPerson" placeholder="默认为使用责任人" />
			</el-form-item> -->
			<el-form-item label="责任人联系电话" required prop="usePersonTel">
				<el-input v-model="form.usePersonTel" placeholder="请输入责任人联系电话" />
			</el-form-item>

			<el-row style="margin-bottom: 15px">
				<span
					>证件类型：<el-radio v-model="radio" label="1">身份证</el-radio>
					<el-radio v-model="radio" label="2">护照(港澳台)</el-radio>
					<el-radio v-model="radio" label="3">护照(国外)</el-radio>
				</span>
			</el-row>

			<span style="position: absolute; color: red; left: 10px; top: 14px">*</span>
			<el-form-item v-if="radio == 1" label="责任人身份证号" required prop="usePersonId">
				<el-input v-model="form.usePersonId" placeholder="请输入责任人身份证号" />
			</el-form-item>
			<el-form-item v-else-if="radio == 2" label="责任人护照证号" required prop="usePersonId">
				<el-input v-model="form.usePersonId" placeholder="请输入责任人护照证号(港澳台)" />
			</el-form-item>
			<el-form-item v-else label="责任人护照证号" prop="usePersonId" required>
				<el-input v-model="form.usePersonId" placeholder="请输入责任人护照证号(国外)" />
			</el-form-item>
			<el-form-item label="责任人电子邮箱" prop="usePersonEmail" required>
				<el-input v-model="form.usePersonEmail" placeholder="请输入责任人电子邮箱" />
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
	name: 'addSampleInfo',
	components: {},
	data() {
		// 自定义护照校验函数（核心）
		const validatePassport = (rule, value, callback) => {
			// 1. 非空校验（可根据需求是否必填）
			if (!value) {
				return callback(new Error('请输入护照号码'))
			}

			// 2. 护照格式正则校验（使用综合正则）
			const regChinaPassport = /^(G|EG|E)\d{8}$|^P\d{7}$|^D\d{7}$/
			if (!regChinaPassport.test(value)) {
				return callback(new Error('请输入有效的中国护照号码（如G12345678、P1234567）'))
			}

			// 3. 校验通过
			callback()
		}
		return {
			radio: '1',
			deptData: [],
			typeData: '',
			// 使用方式改成这些 ;1:原样使用,2:消耗使用,3:破坏性使用,4:展览教育科普,5:礼品,7:其他 展览教育科普合成一个 新加一个礼品
			useTypeOption: [
				{ label: '原样使用', value: '1' },
				{ label: '消耗使用', value: '2' },
				{ label: '破坏性使用', value: '3' },
				{ label: '展览教育科普', value: '4' },
				{ label: '赠送', value: '5' },
				// { label: '科普', value: '6' },
				{ label: '其他', value: '7' }
			],
			form: {
				createBy: null,
				sampleDataId: null,
				useType: null,
				testPerson: null,
				orderNo: null,
				companyName: null,
				useTarget: '科学研究',
				useExplain: null,
				legalPerson: null,
				legalPersonId: null,
				legalPersonTel: null,
				legalPersonEmail: null,
				usePerson: null,
				usePersonId: null,
				usePersonTel: null,
				usePersonEmail: null,
				expectedReturnTime: null,
				actualReturnTime: null,
				borrowWeight: null,
				returnWeight: null,
				expectedConsumption: null,
				actualConsumption: null,
				useStartTime: null,
				useEndTime: null,
				status: null,
				borrowReview: null,
				borrowReviewReason: null,
				borrowReviewTime: null,
				returnReview: null,
				returnReviewTime: null,
				returnReviewReason: null
			},
			rules: {
				borrowWeight: [
					{ required: true, message: '请填写样品借用质量', trigger: 'blur' },
					{ pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的样品借用质量，最多两位小数', trigger: 'blur' }
				],
				expectedConsumption: [
					{ required: true, message: '请填写预期消耗量', trigger: 'blur' },
					{ pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的预期消耗量，最多两位小数', trigger: 'blur' }
				],
				companyName: [{ required: true, message: '请选择样品使用单位/场所', trigger: 'blur' }],
				useStartTime: [{ required: true, message: '请选择开始使用时间', trigger: 'change' }],
				useEndTime: [{ required: true, message: '请选择结束使用时间', trigger: 'change' }],

				expectedReturnTime: [{ required: true, message: '请选择预计返还时间', trigger: 'change' }],
				useType: [{ required: true, message: '请至少选择一个使用性质', trigger: 'change' }],
				usePersonEmail: [
					{ required: true, message: '请填写责任人电子邮箱', trigger: 'blur' },
					{ type: 'email', message: '请输入有效的邮箱地址', trigger: ['blur', 'change'] }
				],
				legalPersonEmail: [
					{ required: true, message: '请填写法人电子邮箱', trigger: 'blur' },
					{ type: 'email', message: '请输入有效的邮箱地址', trigger: ['blur', 'change'] }
				],
				usePerson: [{ required: true, message: '请填写借用责任人', trigger: 'blur' }],
				usePersonId: [
					{ required: true, message: '请填写责任人身份证号', trigger: 'blur' }
					// { pattern: /(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入有效责任人身份证号', trigger: ['blur'] }
				],
				usePersonTel: [{ required: true, message: '请填写责任人电话', trigger: 'blur' }],
				useTarget: [{ required: true, message: '请填写使用目的', trigger: 'blur' }]
			}
		}
	},
	watch: {
		radio(val) {
			this.form.usePersonId = ''
		}
	},
	mounted() {
		this.getUsePartInfo()
	},
	methods: {
		// 自定义国外护照校验函数（核心）
		validateIdCard3(val) {
			// 1. 非空校验（如需必填则保留，非必填可注释/修改）
			if (!this.form.usePersonId || this.form.usePersonId == '') {
				this.$message.warning('请输入护照号码')
				return false
			}

			// 2. 主流国家护照综合正则校验（可根据业务需求调整/扩展）
			const regForeignPassport = /^(?:[A-Z]\d{8}|[A-Z0-9]{9}|[A-Z]{2}\d{6,7}|[A-Z]\d{7}|[A-Z]{2}\d{6}|\d{8}|[A-Z]\d{7}|[A-Z0-9]{9,12}|[A-Z0-9-]{6,14})$/

			// 格式化处理：忽略首尾空格（可选，提升用户体验）
			const passportValue = this.form.usePersonId.trim().toUpperCase() // 统一转为大写，兼容小写输入

			if (!regForeignPassport.test(passportValue)) {
				this.$message.warning('请输入有效的国外护照号码（支持美/英/加/澳等主流国家）')
				return false
				// return callback(new Error('请输入有效的国外护照号码（支持美/英/加/澳等主流国家）'));
			}
			// // 3. 校验通过
			// callback();
			return true
		},
		validateIdCard2(value) {
			// 1. 非空校验（可根据需求是否必填）
			if (!this.form.usePersonId || this.form.usePersonId == '') {
				this.$message.warning('请输入护照号码')
				return false
			}
			// 2. 护照格式正则校验（使用综合正则）
			const regChinaPassport = /^(G|EG|E)\d{8}$|^P\d{7}$|^D\d{7}$/
			if (!regChinaPassport.test(this.form.usePersonId)) {
				// return callback(new Error('请输入有效的中国护照号码（如G12345678、P1234567）'))
				this.$message.warning('请输入有效的中国护照号码（如G12345678、P1234567）')
				return false
			}
			return true
		},
		// 验证身份证号
		validateIdCard(val) {
			const idCardReg = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/
			if (!this.form.usePersonId) {
				this.idCardError = '请输入身份证号'
				this.$message.warning('请输入身份证号')
				return false
			} else if (!idCardReg.test(this.form.usePersonId)) {
				this.idCardError = '请输入正确的18位身份证号'
				this.$message.warning('请输入正确的18位身份证号')
				return false
			} else {
				// 可选：进一步验证出生日期合法性
				return this.validateBirthday()
				// this.idCardError = ''
				// return true
			}
		},
		// 验证出生日期（可选）
		validateBirthday() {
			const id = this.form.usePersonId
			const birthYear = id.substr(6, 4)
			const birthMonth = id.substr(10, 2)
			const birthDay = id.substr(12, 2)
			const birthDate = new Date(`${birthYear}-${birthMonth}-${birthDay}`)

			// 检查日期是否有效（如月份不能超过12，日期不能超过当月最大天数）
			if (birthDate.getFullYear() != birthYear || birthDate.getMonth() + 1 != birthMonth || birthDate.getDate() != birthDay) {
				// this.idCardError = '身份证号中的出生日期无效'
				this.$message.warning('身份证号中的出生日期无效')
				return false
			}
			return true
		},
		chageDep(itemName) {
			const currentData = this.deptData.filter((item) => item.deptName === itemName)
			this.form.legalPerson = currentData[0].leader
			// this.form.usePersonEmail = currentData[0].email
			// this.form.usePersonTel = currentData[0].phone
		},
		// 获取使用单位信息
		async getUsePartInfo() {
			let res = await this.$http.get(this.$const.moonSample.systemDeptList)
			if (res && res.code == 200) {
				this.deptData = res.data
				console.log(this.deptData)
			}
		},
		// 获取用户信息
		async getUseInfo() {
			let res = await this.$http.get(this.$const.common.GETuserInfo)
			if (res && res.code == 200) {
				console.log(res)
				this.form.usePerson = res.user.nickName
				this.form.usePersonTel = res.user.phoneNumber
				this.form.usePersonEmail = res.user.email
				this.form.companyName = res.user.dept.deptName
				this.form.legalPerson = res.user.dept.leader
			}
		},
		initForm(item) {
			console.log(item)
			this.form = item
			this.form.useTarget = '科学研究'
			this.form.status = 0
			this.form.sampleDataId = item.id
			this.form.orderNo = item.code
			this.typeData = item.sampleCategory3
			if (this.form.orderNo.includes('YJYX') || this.form.orderNo.includes('GP')) {
				this.typeData = '岩屑样'
			}
			if (item.sampleCategory3 == '岩屑样') {
				this.form.borrowWeight = item.currentWeight
			}
			// this.getUsePartInfo()
			this.getUseInfo()
			return this.form
		},
		submitFunc() {
			let idFlag = false
			if (this.radio == 1) {
				idFlag = this.validateIdCard()
			} else if (this.radio == 2) {
				idFlag = this.validateIdCard2()
			} else {
				// idFlag = this.validateIdCard3()
			}
			if (!idFlag) {
				return false
			}
			let flag = false
			this.$refs['form'].validate((valid) => {
				if (valid) {
					flag = true
				} else {
					flag = false
				}
			})
			return flag
		}
	}
}
</script>

<style lang="scss" scoped>
</style>